import {each} from "lodash";
import * as lscache from "lscache";
import {Dispatch} from "redux";
import {addAlert, AlertType} from "@web2/ap-alerts";
import {apiLink} from "@web2/ap-api-routes";
import {catch400, postRequest} from "@web2/ap-request";
import {createRequestActionTypes} from "@web2/ap-request-state";
import {apAppLink} from "@web2/ap-routes";

import {apHistory} from "../../app/utils/history";
import {APLocalStorageKeys} from "../../app/utils/ls_cache_keys";

interface LogInResponse {
    auth_token: string;
}

export const logInErrorText = "Błąd logowania";

const USER_IS_AUTHENTICATED = "user_auth/IS_AUTHENTICATED";
export const userIsAuthenticatedActionTypes = createRequestActionTypes(USER_IS_AUTHENTICATED);

export function logIn(email: string, password: string, next?: string) {
    return (dispatch: Dispatch) => {
        dispatch({type: userIsAuthenticatedActionTypes.start});

        return postRequest({}, apiLink.account.login({})(null), {email, password})
            .then((json: LogInResponse) => {
                lscache.set(APLocalStorageKeys.USER_DATA, {apikey: json.auth_token});
                dispatch({type: userIsAuthenticatedActionTypes.success, result: true});

                apHistory.push((next && decodeURIComponent(next)) || apAppLink.applications());
                return json;
            })
            .catch(
                catch400((responseError) => {
                    dispatch({type: userIsAuthenticatedActionTypes.error, result: true});

                    if (responseError.appError?.nonFieldErrors) {
                        each(responseError.appError.nonFieldErrors, (message: string) => {
                            dispatch(addAlert({type: AlertType.ERROR, text: `${logInErrorText}: ${message}`}, 4000));
                        });
                    }
                    return responseError.appError;
                })
            );
    };
}
